/**
 * Exclude VIP / archive sale products from non-collection listings (Board Finder, search).
 * Matches Liquid snippet via product tag ArchiveSale2026 (and template hidden-product).
 * Collection pages (including variant-filter) show tagged products again.
 */
(() => {
  const HIDDEN_LISTING_TAGS = ['ArchiveSale2026'];

  function allowHiddenProductsOnPage() {
    const body = document.body;
    return (
      (body && body.classList.contains('template-collection')) ||
      document.documentElement.classList.contains('template-collection')
    );
  }

  function isHiddenFromListings(product) {
    if (!product || allowHiddenProductsOnPage()) return false;
    const tags = product.tags || [];
    return HIDDEN_LISTING_TAGS.some((tag) => tags.includes(tag));
  }

  function filterProducts(products) {
    return (products || []).filter((product) => !isHiddenFromListings(product));
  }

  window.inlandetHiddenProducts = {
    tags: HIDDEN_LISTING_TAGS,
    allowHiddenProductsOnPage,
    isHiddenFromListings,
    filterProducts,
  };
})();
